import { Subject } from "rxjs";
import { merge } from "lodash-es";
import { Bundler } from "./config.enum.es.js";
import { CompanyId, Theme } from "./config.enum.es.js";
const cfgChangesSubject = new Subject();
const configObservable = cfgChangesSubject.asObservable();
const config = {
  // default config values
  companyCountry: "SK",
  phonePrefixes: [],
  bounds: {
    east: 16.8799829444,
    south: 47.7584288601,
    west: 22.5581376482,
    north: 49.5715740017
  },
  languages: {},
  currency: "EUR",
  validationApiUrl: "https://api-cart.websupport.sk/",
  bundler: Bundler.webpack,
  googleMapsAPIKey: null
};
function setConfigValues(newValues) {
  merge(config, newValues);
  cfgChangesSubject.next(config);
}
export {
  Bundler,
  CompanyId,
  Theme,
  config,
  configObservable,
  config as default,
  setConfigValues
};
//# sourceMappingURL=config.service.es.js.map
